/**
 * The Sample class creates objects that hold memory analysis information over distinct durations.
 * For Flash Player debugger version only.
 */
var Sample = (function () {
    function Sample() {
    }
    return Sample;
}());
export { Sample };
